import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SortTableCellTextPill} from '../../../../../shared/models/sort-table/cell-classes';
import {BaseCellComponent} from '../_base-cell/base-cell.component';
import {PillComponent} from '../../../pill/pill.component';
import {NgClass} from '@angular/common';

/**
 * Produces a cell that has both a title and a subtitle. The subtitle
 * is enclosed in a pill.
 */
@Component({
  selector: 'motn-sort-table-cell-text-pill',
  template: `
    @if (cell.pillText || cell.pillLetter) {
      <motn-pill
        [color]="cell.pillColor"
        [fill]="cell.pillFill || 'outline'"
        [squareLetter]="cell.pillLetter"
        [monospace]="cell.monospacePill"
        [ngClass]="{
          'first': cell.showPillFirst
        }"
        (click)="onClick()"
      >{{ cell.pillText }}</motn-pill>
    }

    @if (cell.mainText || cell.displayName || cell.facetValues?.length) {
      <div class="text-container">
        @if (cell.mainText) {
          <div
            [attr.data-color]="cell.mainTextColor"
            [ngClass]="{'monospace': cell.monospaceText}"
            (click)="onClick()"
          >
            @if (cell.mainTextIcon) {
              <i [ngClass]="['fa-regular', 'fa-'+cell.mainTextIcon]"></i>
            }
            {{ cell.mainText }}
          </div>
        }

        @if (cell.facetValues?.length) {
          <div class="facets">
            @for (val of cell.facetValues; track $index) {
              @if (!$first) {<i class="fa-solid fa-circle-dot"></i>}
              <span>{{ val }}</span>
            }
          </div>
        }

        @if (cell.displayName) {
          <div class="display-name" [innerText]="cell.displayName"></div>
        }
      </div>
    }
  `,
  styleUrls: ['./sort-table-cell-text-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PillComponent,
    NgClass,
  ],
})
export class SortTableCellTextPillComponent extends BaseCellComponent implements OnInit {
  @Input() cell: SortTableCellTextPill;


  constructor() {
    super();
  }


  protected onInit(): void {
  }


  onClick() {
    if (this.cell.clickCallback) {
      this.cell.clickCallback();
    }
  }
}
